// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"2121779a","900":"65bfeb6b"}[chunkId] + ".chunk.css";
};